
import React from 'react'
import AppRouter from '../../router/AppRouter';
import Shimmer from '../Shimmer/Shimmer';
import FormContext from "../../context/form-context";
import useApp from "./useApp"
import InformationModal from '../Modal/InformationModal';
import BackDropLoader from '../Loader/BackDropLoader';
import { setAlert } from '../../state/action';

function App() {

  const { appState, dispatch } = useApp();
  return (
    <div>
      <FormContext.Provider value={{ appState, dispatch }}>
        {appState.loading ?
          // <Shimmer />
          <BackDropLoader></BackDropLoader> 
          :
          <>
            <AppRouter />
              <InformationModal
                open={appState.alert.show}
                title={appState.alert.title}
                body={appState.alert.body}
                onClose={() => dispatch(setAlert({...appState.alert , show: false}))}
                buttonLabel={appState.alert.btnLabel}
                buttonAction={appState.alert.btnFunc}
                showBtn={appState.alert.showBtn}
              />
              {/* <BackDropLoader></BackDropLoader> */}

          </>

        }
      </FormContext.Provider>
    </div>
  );
}


export default App;
